// @ts-strict-ignore
/**
 * @fileoverview > handler for the "/integrations/direct/cdi/import-keys-generate" endpoint
 * @owner @Appboy/cdit
 */
import fetch from "@lib/fetch";
import sharedConstants from "@lib/shared_constants";

import type { CdiImportKey } from "../integrationsCdiImport";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiImportKeysGenerateCacheKeys } from "./constants";
import type { CreateCdiImportKeyErrors, PostIntegrationsDirectCdiImportKeysGenerateProps } from "./types";

export const postIntegrationsDirectCdiImportKeysGenerate = reactQueryMutationAdapter(
  integrationsDirectCdiImportKeysGenerateCacheKeys,
  (props: PostIntegrationsDirectCdiImportKeysGenerateProps): Promise<CdiImportKey | CreateCdiImportKeyErrors> => {
    // BigQuery and GCS credentials upload a service-account JSON key file, so they
    // must POST as multipart form data instead of JSON.
    if (
      props.partner_name === sharedConstants.DATALAKE.PARTNER_NAME.bigquery.name ||
      props.partner_name === sharedConstants.DATALAKE.PARTNER_NAME.gcs.name
    ) {
      const body = new FormData();
      for (const key in props) {
        body.append(key, props[key]);
      }
      return fetch(
        "/integrations/direct/cdi/import-keys-generate",
        "POST",
        {},
        { body },
        { setContentType: false }
      );
    }

    return fetch("/integrations/direct/cdi/import-keys-generate", "POST", { ...props });
  }
);
